import { render } from "./mobile-menu.vue?vue&type=template&id=4ce4f73a"
import script from "./mobile-menu.vue?vue&type=script&lang=js"
export * from "./mobile-menu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__